'use strict';

class CreditNoteView {
  constructor($routeParams, $location, creditNoteService, salesLedgerService) {
    this.$location = $location;
    this.creditNoteService = creditNoteService;
    this.salesLedgerService = salesLedgerService;

    this.number = $routeParams.number;
  }

  $onInit() {
    this.creditnote = {};
    this.salesledger = {
      invoice: 0,
      recipient: 0,
      entries: []
    };

    this.load();
  }

  load() {
    this.creditNoteService.get(this.number)
      .then((resp) => {
        this.creditnote = resp.data;
        return resp.data;
      })
      .then((creditnote) => {
        if (creditnote.creditedInvoiceNumber) {
          // get sl entries
          this.salesLedgerService.getInvoiceEntries(creditnote.creditedInvoiceNumber)
            .then((entries) => {
              this.salesledger.entries = entries.data;
            });
        }
      })
      .catch((err) => {
        if (err.status === 404) {
          this.$location.path('/beslutning-kreves');
        }
      });
  }
}

CreditNoteView.$inject = ['$routeParams', '$location', 'creditNoteService', 'salesLedgerService'];

const creditNoteView = {
  controller: CreditNoteView,
  templateUrl: 'credit-note/view.html'
};

angular
  .module('SendRegning')
  .component('creditNoteView', creditNoteView)
  .config(($routeProvider) => {
    $routeProvider
      .when('/kreditnota/:number', {
        title: 'Vis kreditnota',
        template: '<credit-note-view />',
        secure: true
      });
  });
